import {SvgProps} from '../svgProps';
import {useSvg} from '../useSvg';

export function TrustSvg(props: SvgProps) {
  const {fill, gradientMaybe} = useSvg(props);
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={props.className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.9998 1.28003L25.2385 2.25717C31.2107 6.96833 38.0346 6.93178 40.6537 6.91775C40.7839 6.91706 40.9037 6.91642 41.0125 6.91642H43.0446L43.0122 8.94831C42.8889 16.6808 42.5608 22.3176 41.9192 26.5433C41.2772 30.7716 40.3003 33.7434 38.775 36.0405C37.2348 38.3602 35.2561 39.8057 33.0151 41.1712C32.2582 41.6324 31.4874 42.0766 30.6818 42.5408C29.0333 43.4907 27.2393 44.5245 25.1216 45.9593L23.9999 46.7194L22.8781 45.9594C20.7636 44.527 18.9735 43.4948 17.3287 42.5465C16.5202 42.0804 15.7469 41.6345 14.9874 41.1712C12.7481 39.8054 10.7722 38.3595 9.23522 36.0391C7.71345 33.7418 6.73998 30.77 6.10065 26.5423C5.46167 22.3169 5.13549 16.6804 5.01273 8.94816L4.98047 6.91642H7.01247C7.11988 6.91642 7.23834 6.91706 7.36723 6.91775C9.96265 6.93179 16.7884 6.96872 22.7611 2.25717L23.9998 1.28003ZM9.01258 8.90681C12.3992 8.81493 18.5204 8.14987 23.9998 3.82741C29.4862 8.15536 35.6153 8.81661 39.0124 8.90715C39.6628 8.92449 40.213 8.9209 40.6394 8.91812C40.7769 8.91723 40.9015 8.91642 41.0125 8.91642C41.0016 9.60009 40.9891 10.2666 40.9749 10.9164C40.4586 34.5935 37.7315 36.166 29.7672 40.7585C28.0872 41.7272 26.1742 42.8303 23.9998 44.3036C21.8292 42.8331 19.9198 41.7315 18.2431 40.7641C10.2772 36.168 7.5639 34.6025 7.04988 10.9165C7.03578 10.2666 7.02333 9.60009 7.01247 8.91642C7.12195 8.91642 7.24511 8.91722 7.38117 8.91812C7.80684 8.92092 8.35874 8.92454 9.01258 8.90681Z'
        fill={fill}
      />
      <defs>{gradientMaybe}</defs>
    </svg>
  );
}
